import { jsx as _jsx } from "react/jsx-runtime";
import { Timeline as ExperimentalTimeline } from "@/components/ui/ExperimentalTimeline";
import { TimelineItem } from "./TimelineItem";
import { useVerticalExternalTimelineProcessController } from "./useVerticalTimelineProcessController";
export default function VerticalExternalTimelineProcess(_a) {
    var data = _a.data;
    var _b = useVerticalExternalTimelineProcessController({
        data: data,
    }), steps = _b.steps, isLastStep = _b.isLastStep;
    return (_jsx(ExperimentalTimeline, { children: steps.map(function (step, index) { return (_jsx(TimelineItem, { step: step, externalProcess: data, index: index, isLastStep: isLastStep }, index)); }) }));
}
